import i18n from '@/lang/vue-18n';

export default class RoundStatus {
    static readonly UPCOMING = new RoundStatus('upcoming', 'orange');
    static readonly IN_PROGRESS = new RoundStatus('in_progress', 'green');
    static readonly ENDED = new RoundStatus('ended', 'red');
    static readonly UNKNOWN = new RoundStatus('unknown', 'gray');

    private static readonly VALUES = [RoundStatus.UPCOMING, RoundStatus.IN_PROGRESS, RoundStatus.ENDED];

    static parse(name: string): RoundStatus {
        return RoundStatus.VALUES.find(s => s.name == name) || RoundStatus.UNKNOWN;
    }

    public style: string[]

    private constructor(public readonly name: string, public readonly color: string) {
        this.style = [`bg-${color}-100`, `text-${color}-800`];
    }

    public translateName(): string {
        return i18n.global.t(`round_status.${this.name}`)
    }
}
